// extracted by mini-css-extract-plugin
export default {"list-container":"accidentlist_list-container__mQpAu","title":"accidentlist_title__Cz17H","item-flex":"accidentlist_item-flex__Pn1dh"};